import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { PersonaService, MenuFuncionService, TenantService, TipoDocumentoService } from '../../../../../src/app/shared/services';
import { MenuFuncionCodes, LocalStorageKeys, TenantFeatureFlags, SavePersonaDto, SearchTipoDocumentoRequest, TipoDocumento, SearchPersonaRequestDto, DialogConfirmRequest, DialogConfirmResponse,
  Persona, DialogPersonaGestionRequestDto, DialogPersonaGestionResponseDto
 } from '../../../../../src/app/shared/model';
import { DialogConfirmComponent } from '../../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-dialogPersonaGestion',
  templateUrl: 'dialogPersonaGestion.component.html',
  styleUrls: ['./dialogPersonaGestion.component.css']
})

export class DialogPersonaGestionComponent implements OnInit {

  formGroup: FormGroup;

  tenantFeatureFlags: TenantFeatureFlags;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isTipoDocumentoSearching: boolean = false;
  isPersonaDataSearching: boolean = false;

  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;
  showCuit: boolean = false;

  msgError: string = "";

  item: Persona;

  tipoDocumentoList: TipoDocumento[];
  personaSearchResult: Persona | null;

  constructor(
    private dialogRef: MatDialogRef<DialogPersonaGestionComponent>,
    @Inject(MAT_DIALOG_DATA) public input: DialogPersonaGestionRequestDto,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private sharedFunctions: SharedFunctions,
    private menuService: MenuFuncionService,
    private tipoDocumentoService: TipoDocumentoService,
    private tenantService: TenantService,
    private personaService: PersonaService
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.UNIDAD_FUNCIONAL).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_EDIT);
            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_LIST);
            this.canDelete = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_DELETE);

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isSearching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.getTiposDocumento();
    this.loadEntity();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
      'Apellido': [null, [Validators.required, Validators.maxLength(150)]],
      'TipoDocumentoId': [null],
      'NroDocumento': [null, Validators.maxLength(100)],
      'Cuit': [null],
      'MailContacto': [null, [Validators.maxLength(255), Validators.email]],
      'MovilContacto': [null, Validators.maxLength(100)]
    });
  }

  getTiposDocumento() {
    var r = new SearchTipoDocumentoRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoDocumentoSearching = true;

    this.tipoDocumentoService.search(r).subscribe(data => {
      this.isTipoDocumentoSearching = false;
      if (data != null) {
        this.tipoDocumentoList = data?.result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isTipoDocumentoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  loadEntity() {
    if (this.input != null && this.input.Id > 0) {
      if (this.canView || this.canEdit) {
        this.isSearching = true;
        this.personaService.get(this.input.Id).subscribe(data => {
          this.isSearching = false;
          if (data != null && data.Success) {
            this.item = data.Result;

            if (this.item != null && this.item.Id != null && this.item.Id > 0) {
              if (this.canEdit) {
                this.formGroup.patchValue(this.item);
              }
            }
            else
              this.msgError = "No se encontró el item seleccionado.";
          }
          else
            this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
        },
        (err: HttpErrorResponse) => {
          this.isSearching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    }
    else {
      if (this.canAdd) {
        this.item = new Persona(null, null, null, null, null, null, null, null, null,null, true, null, null, null);
        this.formGroup.patchValue(this.item);
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    }
  }

  getErrorNombre() {
    var v = this.formGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorApellido() {
    var v = this.formGroup.get('Apellido');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorTipoDocumentoId() {
    return this.formGroup.get('TipoDocumentoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorNroDocumento() {
    var v = this.formGroup.get('NroDocumento');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorCuit() {
    return this.formGroup.get('Cuit')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorMailContacto() {
    var v = this.formGroup.get('MailContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  getErrorMovilContacto() {
    var v = this.formGroup.get('MovilContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  onTipoDocumentoSelection() {
    var tipoDoc: TipoDocumento | null = null;
    if (this.tipoDocumentoList != null)
      tipoDoc = (this.tipoDocumentoList.filter(f => f.Id == this.formGroup?.get("TipoDocumentoId")?.value))[0];
    this.showCuit = !(tipoDoc?.Nombre?.toUpperCase() == "CUIT" || tipoDoc?.Nombre?.toUpperCase() == "CUIL");
    this.checkPersonaExistance(true, false);
  }

  onNroDocumentoChange() {
    this.checkPersonaExistance(true, false);
  }

  onCuitChange() {
    this.checkPersonaExistance(false, true);
  }

  checkPersonaExistance(searchByDoc: boolean, searchByCuit: boolean) {
    var tipoDocId = this.formGroup?.get("TipoDocumentoId")?.value;
    var nroDoc = this.formGroup?.get("NroDocumento")?.value;
    var cuit = this.formGroup?.get("Cuit")?.value;

    if ((tipoDocId > 0 && nroDoc?.length > 0) || cuit?.length > 0) {
      var r = new SearchPersonaRequestDto(null, null, true, "Apellido", null, null, tipoDocId, nroDoc, null, null, null, true, false);
      if (searchByCuit)
        r = new SearchPersonaRequestDto(null, null, true, "Apellido", null, null, null, null, cuit, null, null, true, false);

      this.isPersonaDataSearching = true;

      this.personaService.search(r).subscribe(data => {
        this.isPersonaDataSearching = false;
        if (data != null && data.result != null && data.result.length > 0) {
          this.personaSearchResult = data?.result[0];

          if (this.personaSearchResult?.Id == this.item?.Id) {
            this.personaSearchResult = null;
            return;
          }

          var msg = "Se encontró a la persona " + this.personaSearchResult?.Nombre + " " + this.personaSearchResult?.Apellido;
          if (searchByDoc) msg +=" en base al tipo y nro. de documento ingresado. ";
          if (searchByCuit) msg +=" en base al CUIT/CUIL ingresado. ";
          msg += "\n\n¿Desea cargar los datos encontrados?"

          const dialogRef = this.dialog.open(DialogConfirmComponent, {
            data: new DialogConfirmRequest("Persona encontrada", msg, "Sí, carga los datos", "No cargues nada")
          });

          dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
            if (result != null && result.Accepted)
              this.cargarPersonaEncontrada();
            else
              this.noCargarPersonaEncontrada();
          });
        }
      },
      (err: HttpErrorResponse) => {
        this.isPersonaDataSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  cargarPersonaEncontrada() {
    if (this.personaSearchResult != null && this.personaSearchResult.Id != null && this.personaSearchResult.Id > 0) {
      this.item = this.personaSearchResult;
      this.formGroup.patchValue(this.item);

      this.personaSearchResult = null;
    }
  }

  noCargarPersonaEncontrada() {
    this.personaSearchResult = null;
  }

  onGuardar() {
    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SavePersonaDto(0, null, null, null, null, null, null, null, null, true, null, null, null, null, null, null);

    r =
    {
      ...this.formGroup.value,
      ... {
        Id: (this.item?.Id ?? 0),
        Activo: this.item.Activo
      }
    };

    this.isSaving = true;
    this.personaService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        var p = data.Result;

        var td = this.tipoDocumentoList.find(f => f.Id == this.formGroup.get("TipoDocumentoId")?.value)
        if (td != null)
          p.TipoDocumentoNombre = td?.Nombre;

        this.dialogRef.close(new DialogPersonaGestionResponseDto(false, p));
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.dialogRef.close(new DialogPersonaGestionResponseDto(true, null));
  }
}
